import { IS_POWERED_BY_PLUGIN } from '../utils/constant'
const dataObj = {
  props: {},
  event: {}
}
function getData (key) {
  let data = JSON.parse(JSON.stringify(dataObj))
  if (IS_POWERED_BY_PLUGIN) {
    data = {
      ...dataObj,
      ...window.microApp.getData()
    }
  }
  return data[key]
}

function dispatch (data) {
  if (IS_POWERED_BY_PLUGIN) {
    window.microApp.dispatch(data)
  }
}

function addDataListener (key, cb) {
  if (IS_POWERED_BY_PLUGIN) {
    window.microApp.addDataListener((data) => {
      console.log('[@ccprivate/plugin-engine-saas][plugin-wrapper] addListener', key, data)
      cb(data[key])
    }, true)
  }
}

export function getAppProps () {
  return getData('props')
}
export function getAppEvents () {
  return getData('event')
}
export function getAppData () {
  return getData('data')
}
export function getAppOptions () {
  return getData('options')
}
export function dispatchComponentInstance (componentInstance) {
  dispatch({ componentInstance })
}

export function dataListener (cb) {
  addDataListener('data', cb)
}
export function eventsListener (cb) {
  addDataListener('event', cb)
}
export function propsListener (cb) {
  addDataListener('props', cb)
}
export function optionsListener (cb) {
  addDataListener('options', cb)
}
